import { createApp } from 'vue';
import XlsxToPdfAConverter from '../Components/XlsxToPdfAConverter.vue';
import '@styles/app.css';

createApp(XlsxToPdfAConverter).mount('#xlsx-to-pdfa-converter');
